module.exports = __webpack_public_path__ + "img/progress-none.28c2c28f.png";